import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-oakville',
  templateUrl: './oakville.component.html',
  styleUrls: ['./oakville.component.css']
})
export class OakvilleComponent implements OnInit {

  constructor(private router: Router) {

    localStorage.setItem("currentPostalCode", 'L4X');
    localStorage.setItem("comingFromFranchise", 'Yes');
    //this.router.navigate(["home", "oakville"]);
  }

  ngOnInit() {
  }

}
